import { ReactNode, useState } from 'react';
import { tv } from 'tailwind-variants';

import Marquee from '@cartwhl/ui/atoms/Marquee';
import Reveal from '@cartwhl/ui/atoms/Reveal';
import Video from '@cartwhl/ui/atoms/Video';
import Text from '@cartwhl/ui/base/Text';

const item = tv({
  variants: {
    variant: {
      grid: 'flex flex-col gap-4',
      list: 'flex w-full flex-row gap-8 border-b pb-8',
    },
  },
  defaultVariants: {
    variant: 'list',
  },
});

const media = tv({
  variants: {
    variant: {
      grid: 'bg-gray-30 hover:shadow-menu aspect-square w-full rounded-2xl transition-shadow',
      list: 'bg-gray-30 hover:shadow-menu aspect-square h-full w-[150px] min-w-[150px] rounded-2xl transition-shadow',
    },
  },
  defaultVariants: {
    variant: 'list',
  },
});

const footer = tv({
  variants: {
    variant: {
      grid: 'relative flex grow flex-col flex-nowrap items-start gap-3 pb-2',
      list: 'relative flex grow flex-col flex-nowrap py-2',
    },
  },
  defaultVariants: {
    variant: 'list',
  },
});

export default function GalleryCard({
  className,
  variant = 'list',
  url,
  title,
  src,
  children,
  isMarquee = false,
}: {
  className?: string;
  variant?: 'grid' | 'list';
  url?: string;
  title?: string;
  src?: string;
  children?: ReactNode;
  isMarquee?: boolean;
}) {
  const [hovering, setHovering] = useState<boolean>(false);

  return (
    <div
      className="group"
      onPointerEnter={() => setHovering(true)}
      onPointerLeave={() => setHovering(false)}
    >
      <Reveal
        threshold={0.1}
        transition="fade"
        duration="100"
        className={item({ variant, className })}
      >
        <a href={url} className={media({ variant })}>
          {src && (
            <Video
              src={src}
              className="h-full w-full rounded-[inherit] object-cover"
              mode={'autoplay'}
              crossOrigin="use-credentials"
            />
          )}
        </a>
        <div className={footer({ variant })}>
          {title && isMarquee && <Marquee playing={hovering}>{title}</Marquee>}
          {title && !isMarquee && (
            <Text as="p" variant="studio/body/md">
              {title}
            </Text>
          )}
          {children}
        </div>
      </Reveal>
    </div>
  );
}
